/**
 * @module storage
 * @description storage工具类
*/


const NO_EXPIRE_TIME = 0,
    NOT_EXISTED_INDEX = -1;

const structure = ['expires', 'createTime', 'data'];

function now() {
    return new Date().getTime();
}


function dataAdapterMatchStructure(data) {
    let match = false;
    if (data) {
        let dataKeys = Object.keys(data);
        match = JSON.stringify(dataKeys.sort()) === JSON.stringify(structure.sort());
    }
    return match;
}


/**
 *
 * 本地缓存数据处理，解析缓存数据的过期时间存储结构
 * @export
 * @param {*} localStorageData - 本地获取的缓存数据
 * @return {*} 处理后的缓存数据，过期的返回null
 * @example
 const getStorage = (key) => {
    let result;
    try {
        result = window.localStorage.getItem(key);
    } catch (e) {
        console.warn(e);
    }

    result = parseStorageData(result);

    return result;
}
// 浏览器存储结构为：{"expires":10000,"createTime":1678167914847,"data":{"name":"EXPIRE_STORAGE"}}
// return: 未过期:{name: 'EXPIRE_STORAGE'} 过期:null
 */
export function parseStorageData (localStorageData) {
    let storageValue;

    try {
        storageValue = JSON.parse(localStorageData);
    } catch (e) {
        storageValue = localStorageData;
    }

    if(storageValue && dataAdapterMatchStructure(storageValue)){
        // 有过期时间的存储
        if(storageValue.expires === NO_EXPIRE_TIME || storageValue.expires + storageValue.createTime >= now()) {
           return storageValue.data
       } else {
           return null
       }
   } else {
       return storageValue
   }
}




function writeStorage(storage, key, value) {

    const valueStr = typeof value === 'object' ? JSON.stringify(value) : value;

    try {
        storage.setItem(key, valueStr);
    } catch(oException) {
        // ios 隐私模式时，oException.name是QuotaExceededError
        // https://stackoverflow.com/questions/21159301/quotaexceedederror-dom-exception-22-an-attempt-was-made-to-add-something-to-st
        try {
            if(oException.name === 'QuotaExceededError') {
                storage.clear();
                storage.setItem(key, valueStr);
            }
        } catch(e) {}
    }
}

function readStorage(storage, key) {
    let value = storage.getItem(key)
    try {
        return JSON.parse(value);
    } catch(error) {
        return value;
    }
}

/**
 * 获取storage
 * @export
 * @param {string} key 获取缓存的key
 * @return {*} 返回缓存数据，过期缓存会移除
 */
export function getStorage(key) {
    try {
        const sessionValue = readStorage(window.sessionStorage, key);
       
        if (sessionValue) {
            return sessionValue
        }
        const storageValue = parseStorageData(readStorage(window.localStorage, key));

        if(!storageValue) {
            // 兼容过期数据结构，缓存已过期，移除缓存数据
            window.localStorage.removeItem(key)
        }

        return storageValue;
        
    } catch (e) {
        console.warn(e);
    }
}

/**
 * 设置storage
 * @export
 * @param {string} key 设置缓存的key
 * @param {*} data 设置缓存的value
 * @param {number} [expires=0] 缓存过期时间（ms），若没有传过期时间，0-localStorage不过期，-1-seesionStorage
 * @example
    //设置seesionStorage，浏览器里存为：{"name":"SEESION_STORAGE"}
    setStorage("SEESION_STORAGE", {name: "SEESION_STORAGE"}, -1) 
    //设置无过期时间的localStorage，浏览器里存为：{"name":"NO_EXPIRE_STORAGE"}
    setStorage("NO_EXPIRE_STORAGE", {name: "NO_EXPIRE_STORAGE"}) 
    //设置过期时间为10s的localStorage，浏览器里存为：{"expires":10000,"createTime":1678166633976,"data":{"name":"EXPIRE_STORAGE"}}
    setStorage("EXPIRE_STORAGE", {name: "EXPIRE_STORAGE"}, 10000) 
 * 
 */
export function setStorage(key, data, expires = NO_EXPIRE_TIME) {
    try {
        if(expires === NOT_EXISTED_INDEX) {
            writeStorage(window.sessionStorage, key, data);
        } else if (expires !== 0){
            writeStorage(window.localStorage, key, {
                expires: expires,
                createTime: now(),
                data
            });
        } else {
            writeStorage(window.localStorage, key, data);
        }
    } catch (e) {
        console.warn(e);
    } 
    
}


export function removeStorage(key) {
    if (!key) {
        return
    }
    window.localStorage.removeItem(key);
    window.sessionStorage.removeItem(key);  
}